import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appWheelHorizontalScroll]',
  standalone: true
})
export class WheelHorizontalScrollDirective {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if (!event.deltaY) {
      return;
    }

    const container = this.el.nativeElement;
    if (container.scrollWidth <= container.clientWidth) {
      return;
    }

    container.scrollLeft += event.deltaY;
    event.preventDefault();
  }
}
